/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.concat.js";
import request from '@/api/request';
import qs from 'querystring'; // 工单审批

export function orderExamine(data) {
  return request.post('/order/examine/save', data);
} // 服务完成审批

export function applyEndService(data) {
  return request.post('/order/applyEndService', data);
} // 工单打标 获取标签信息

export function getMakeTagList(data) {
  return request.get('/v2/epTag/orderTagList', {
    params: data
  });
} // 工单打标 添加工单标签

export function orderAddTag(data) {
  return request.post('/v2/epTag/orderAddTag', data);
} // 工单留言提交

export function saveMessage(data) {
  return request.post('/v2/order/saveMessage', qs.stringify(data));
} // 工单日志信息

export function batchDesignate(data) {
  return request.post('/worker/batchDesignate', data);
} // 编辑协同人

export function editCoordination(data) {
  return request.post('/worker/editCoordination', data);
} // 服务团队列表

export function getServiceGroupList(data) {
  return request.get('/servicegroup/list', {
    params: data
  });
} // 转派服务团队

export function updateOrderGroupId(data) {
  return request.get('/order/updateOrderGroupId', {
    params: data
  });
} // 接单

export function receiveOrder(data) {
  return request.post('/order/accept', qs.stringify(data));
} // 检查是否可以完成工单

export function checkFinish(data) {
  return request.get("/order/progress/checkFinish?orderId=".concat(data.orderId));
} // 完成工单

export function finishOrder(data) {
  return request.post("/order/serviceComplete", data);
} // 取消工单（除普通员工）

export function cancelOrder(data) {
  return request.post("/order/cancel", qs.stringify(data));
} // 拒绝工单

export function refuseOrder(data) {
  return request.post("/order/refuseOrder", qs.stringify(data));
} // 取消工单（普通员工）Deprecated

export function cancelOrderByEmployee(data) {
  return request.post("/order/employee/cancel", qs.stringify(data));
} // 开始服务

export function startService(data) {
  return request.post("/order/startService", qs.stringify(data));
} // 接单

export function acceptOrder(data) {
  return request.post("/order/accept", qs.stringify(data));
} // 服务收款

export function savePayforImage(data) {
  return request.post("/settlement/savePayforImage", data);
} // 受理、设为无效

export function acceptance(data) {
  return request.post("/order/acceptance", qs.stringify(data));
} // 预约上门

export function workerBespokeDate(data) {
  return request.post("/order/workerBespokeDate", qs.stringify(data));
} // 打印工单

export function printOrder(orderId, code) {
  return request.get("/order/pdfSend/".concat(orderId, "/").concat(code));
} // 申请异常

export function applyAbnormalOrder(data) {
  return request.post("/order/applyAbnormalOrder", qs.stringify(data));
} // 获取评价工单拓展字段

export function getEvalExtField(data) {
  return request.get("/order/evalExtField", {
    params: data
  });
} // 保存评价工单

export function saveEval(data) {
  return request.post("/order/saveEval", data);
} // 异常处理

export function changeOrderAbnormalState(data) {
  return request.post("/order/changeOrderAbnormalState", qs.stringify(data));
} // 工单归档

export function saveOrderArchive(data) {
  return request.put("/v2/order/archive", data);
}